module.exports = __webpack_public_path__ + "img/logosd1.725dccde.png";